import './App.css';

import Menu from './components/Menu';
import FooterControl from './components/FooterControls';

function App() {
 

  return (
    <>
    <Menu></Menu>
    </>
  );
}

export default App;
